/**
 * Prefixo da rota da superfície completa do chat. O orbe flutuante se esconde
 * aqui: `/chat` já é a experiência inteira.
 */
export const IARA_FLOATING_CHAT_ROUTE_PREFIX = '/chat';
